import React from 'react'


import style from '../../../../all.module.css'
import MetadataSection from '../../../../components/Global/MetadataSection/index.js'

const SubTrade = (props) => {
  return (
      <div className={style.ItemsTradeMain}>
        <MetadataSection></MetadataSection>
      </div>
  )
}


export default SubTrade
